import {AfterViewInit, Component, Inject, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {DisplayedColumnInf} from '../../../../interfaces/common/table/displayed-column-inf';
import {TrueFalsePipe} from '../../../../pipes/true-false/true-false.pipe';
import _ from 'lodash';
import {ArmTableComponent} from '../../../../components/arm-table/arm-table.component';
import {NgForm} from '@angular/forms';

@AcDialog({
  height: 600,
  width: 700
})
@Component({
  selector: 'sip-reason-group-duplication-dialog',
  templateUrl: './sip-reason-group-duplication-dialog.component.html',
  styleUrls: ['./sip-reason-group-duplication-dialog.component.scss']
})
export class SipReasonGroupDuplicationDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('sipReasonDuplicateGroupDialog') sipReasonDuplicateGroupDialog: NgForm;
  @ViewChild('sipReasonsTable') sipReasonsTable: ArmTableComponent;

  sipReasonGroup: any;
  sipReason: any;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'checked', display: 'Duplicate', selected: true, width: 50, transformer: TrueFalsePipe},
    {name: 'sipResponseNumber', display: 'SIP Response', selected: true, width: 100},
    {name: 'sipResponseDescription', display: 'Description', selected: true, width: 200},
    {name: 'reroute', display: 'Active', selected: true, transformer: TrueFalsePipe, width: 50},
  ];
  sipReasonsFilter: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.sipReasonGroup = dialogConfig.dialogData;

    this.sipReasonGroup.name = '';
    this.sipReasonGroup.description = '';

    this.sipReasonGroup.sipResponseBehaviors.forEach(s => {
      _.assign(s, {checked: true});
    });

    dialogConfig.preSubmit = () => {
      _.remove(this.sipReasonGroup.sipResponseBehaviors, {checked: false});
    };

    dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {

  }

  onSelection(selected: any): void {
    selected.checked = !selected.checked;
  }

  onFilter(filter: any): void {
    this.sipReasonsTable.firstPage();
    this.sipReasonsFilter = filter;
  }

  ngAfterViewInit(): void {
    this.sipReasonDuplicateGroupDialog.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.sipReasonDuplicateGroupDialog.form.valid;
    });

  }

}
